import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import '../../styles/signIn.scss';

const ALLOWED_DOMAIN = '@mangonelawfirmllc.com';

// Pantalla de auto-registro mostrada por AuthGate cuando el magic link trae el
// query param ?registro=<secret>. El `secret` se reenvía al backend tal cual.
const Register = ({ secret }) => {
  const { register } = useContext(AuthContext);
  const [formData, setFormData] = useState({ email: '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError('');
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email.trim().toLowerCase().endsWith(ALLOWED_DOMAIN)) {
      setError(`Solo se permiten correos ${ALLOWED_DOMAIN}.`);
      return;
    }
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (formData.password !== formData.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await register(formData.email, formData.password, secret);
      // Cuenta creada (sin confirmar) y email de confirmación enviado.
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Could not complete the registration.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1>Mangone Law Firm</h1>
          <h2>Confirmá tu email</h2>
          <p className="auth-notice">
            Te enviamos un email de confirmación a <strong>{formData.email}</strong>.
            Hacé clic en el link del correo para activar tu cuenta y entrar.
          </p>
          <span className="auth-link">¿No lo ves? Revisá la carpeta de spam.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Mangone Law Firm</h1>
        <h2>Create your account</h2>

        <div className="auth-input-container">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="you@mangonelawfirmllc.com"
            value={formData.email}
            onChange={handleChange}
            autoComplete="username"
            required
          />
        </div>

        <div className="auth-input-container">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="auth-input-container">
          <label htmlFor="confirm">Confirm password</label>
          <input
            id="confirm"
            type="password"
            name="confirm"
            placeholder="Confirm password"
            value={formData.confirm}
            onChange={handleChange}
            autoComplete="new-password"
            required
          />
        </div>

        {error && <span className="auth-error">{error}</span>}

        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Creating account...' : 'Create account'}
        </button>
      </form>
    </div>
  );
};

export default Register;
